import { FC } from 'react';

import { Box, Stack, Typography } from '@mui/material';
import { IChildInfo } from 'api/types';
import { useLinkModeStudentName } from 'hooks';
import { portfolioLogo } from 'images';
import TrimText from 'portfolio3/components/common/TrimText';
import { StatusSelector } from 'portfolio3/components/proftech';
import { HeaderAvatar } from 'portfolio3/features/avatar';
import { NeutralColors } from 'portfolio3/styles';

import * as styles from './styles';

interface IUserCardProps {
  student?: IChildInfo;
}

const StudentCard: FC<IUserCardProps> = ({ student }) => {
  const { fullName } = useLinkModeStudentName(student?.firstname, student?.lastname);

  return (
    <Box className="student-card" sx={styles.root}>
      <Box className="student-card__logo" sx={styles.logoContainer}>
        <Box component="img" src={portfolioLogo} alt="логотип" sx={styles.logoImage} />
      </Box>
      <Box className="student-card__content" sx={styles.content}>
        <HeaderAvatar />
        <Stack className="student-card__title">
          <Typography variant="Paragraph MD/Medium" sx={styles.titleContainer} color={NeutralColors.light_neutrals_600}>
            Портфолио
          </Typography>
          <Box className="student-card__name" sx={styles.nameContainer}>
            <Typography component={TrimText} sx={styles.name}>
              {fullName}
            </Typography>
            <StatusSelector />
          </Box>
        </Stack>
      </Box>
    </Box>
  );
};

export default StudentCard;
